export default "__VITE_ASSET__DK4i3S_i__"